var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_119717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8887 12.2227C21.8887 17.7467 17.4111 22.2227 11.8887 22.2227C6.36621 22.2227 1.88867 17.7467 1.88867 12.2227C1.88867 6.70181 6.36621 2.22266 11.8887 2.22266C17.4111 2.22266 21.8887 6.70181 21.8887 12.2227ZM11.8887 14.2388C10.8643 14.2388 10.0338 15.0692 10.0338 16.0936C10.0338 17.118 10.8643 17.9485 11.8887 17.9485C12.9131 17.9485 13.7435 17.118 13.7435 16.0936C13.7435 15.0692 12.9131 14.2388 11.8887 14.2388ZM10.1277 7.57161L10.4268 13.0555C10.4408 13.3121 10.6529 13.513 10.9099 13.513H12.8674C13.1244 13.513 13.3366 13.3121 13.3506 13.0555L13.6497 7.57161C13.6648 7.29443 13.4441 7.06137 13.1665 7.06137H10.6108C10.3332 7.06137 10.1125 7.29443 10.1277 7.57161Z",
    fill: "#DC2626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_119717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1.88867 2.22266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toastError.c310daa53b2a67ecd0b52234e0e73f96.svg";
export { ForwardRef as ReactComponent };